// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__MJ0D8","spin":"Spinner_spin__khPtB"};